import type {SearchCriteriaRaw} from '../../../types';
import {createKeywordRule} from '../keywordRule';
import type {KeywordRule, TSearchTypeKeyword} from '../types';

export type RawKeywordSearchCriteria = SearchCriteriaRaw<TSearchTypeKeyword>;

export const rawKeywordCriteriaToRuleObject = (
	criteria: RawKeywordSearchCriteria,
): KeywordRule => {
	return createKeywordRule({
		includeContents: criteria.value2 === 'true',
		keyword: criteria.value1,
		type: criteria.subtype1,
	});
};

export default rawKeywordCriteriaToRuleObject;
